import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AvailabilityState } from "../reducers"

export const selectAvailabilityState = createFeatureSelector<AvailabilityState>('availability');

export const selectAvailabilityLoading = createSelector(
  selectAvailabilityState,
  (state: AvailabilityState) => state.loading
);

export const selectAvailabilityError = createSelector(
  selectAvailabilityState,
  (state: AvailabilityState) => state.error
);

export const selectAvailabilityList = createSelector(
  selectAvailabilityState,
  (state: AvailabilityState) => state.availabilityList
);